(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers')
        .controller('VisualGuidelinesComponentController', Controller);

    Controller.$inject = ['$scope', 'topBarService'];

    function Controller($scope, topBarService) {
        topBarService.setModule('Visual Guidelines');
        topBarService.setTitleAndIcon('Component', 'fa fa-codepen');
    }
})();